import { render, staticRenderFns } from "./RemoteSelect.vue?vue&type=template&id=ecbb47f2&"
import script from "./RemoteSelect.vue?vue&type=script&lang=js&"
export * from "./RemoteSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib'
installComponents(component, {
  VSelect,
})
